import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { withRouter } from 'react-router'

import { Header as LayoutHeader, Content, Tabs, NavLink } from 'features/layout/components/header'
import { teamLayout } from 'assets/styles/mixins.js'
import variables from 'assets/styles/variables.js'
import { UserPicture, media } from 'gipsy-ui'
import { styles } from 'gipsy-misc'

const mapStateToProps = state => ({
  activeTeamMember: state.teamlist.activeTeamMember
})

class TeamlistHeader extends PureComponent {
  render() {
    const { activeTeamMember } = this.props
    return (
      <Header>
        <Content>
          <SelectedTeamMember>
            {activeTeamMember && (
              <Fragment>
                <UserPicture src={activeTeamMember.picture} size={24} />
                <UserName>{activeTeamMember.displayName || activeTeamMember.email || 'Unknown'}</UserName>
              </Fragment>
            )}
          </SelectedTeamMember>
          <Tabs>
            <NavLink to="/team" exact activeClassName="active">
              <div>Tasks</div>
            </NavLink>
            <NavLink to="/team/archive" exact activeClassName="active">
              <div>Archive</div>
            </NavLink>
          </Tabs>
        </Content>
      </Header>
    )
  }
}

const Header = styled(LayoutHeader)`
  ${teamLayout};
  ${media['phone-wide']`
    top: ${variables.teamMembersHeight}
    border-top: 1px solid ${styles.colors.borderColor};
  `}
`

const SelectedTeamMember = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const UserName = styled.div`
  font-size: ${styles.fonts.fontSizeXSmall};
  font-weight: 500;
  color: ${styles.colors.primaryColor};
  text-align: center;
  word-break: keep-all;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
`

export default withRouter(
  connect(
    mapStateToProps,
    null,
    null,
    {
      pure: true
    }
  )(TeamlistHeader)
)



// WEBPACK FOOTER //
// ./src/features/teamlist/components/header/index.js